import React, { useState } from "react";
import { faSort } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { get, isEmpty } from "lodash";
import { AddToolTip } from "../../../../components";
import { byteConverter, sortArrayOfObjects } from "../../../../utils";

const Documents = ({ loanData }) => {
  const [orderedDocuments, setOrderedDocuments] = useState(
    loanData?.loanDocument
  );
  const [orderBy, setOrderBy] = useState("asc");

  const getURLFromFormData = (id) => {
    return URL.createObjectURL(loanData[`document${id}`]?.[0]);
  };

  return (
    <div className="loan-page-scroll ml-4">
      <div className="d-flex p-3 w-50">
        <div
          className="ft-12 fw-500 loan-label-color w-80- cursor-pointer"
          onClick={() => {
            setOrderedDocuments(
              sortArrayOfObjects(orderedDocuments, "name", orderBy)
            );
            setOrderBy(orderBy == "asc" ? "desc" : "asc");
          }}
        >
          Document Name
          <span>
            <FontAwesomeIcon
              icon={faSort}
              className={"loan-label-color ml-1"}
              style={{ paddingTop: "2px" }}
            />
          </span>
        </div>
        <div
          className="ft-12 fw-500 loan-label-color w-20 cursor-pointer"
          onClick={() => {
            setOrderedDocuments(
              sortArrayOfObjects(orderedDocuments, "size", orderBy)
            );
            setOrderBy(orderBy == "asc" ? "desc" : "asc");
          }}
        >
          Document Size
          <span>
            <FontAwesomeIcon
              icon={faSort}
              className={"loan-label-color ml-1"}
              style={{ paddingTop: "2px" }}
            />
          </span>
        </div>
      </div>
      {!isEmpty(orderedDocuments) ? (
        <>
          {orderedDocuments.map((doc) => {
            const documentURL =
              doc?.url == null
                ? getURLFromFormData(doc?.loanDocumentTypeId)
                : doc?.url;
            return (
              <div className="d-flex justify-content-between loan-document-details w-50">
                <div className="ft-12 fw-500 p-3 w-75">
                  <a
                    href={documentURL ?? "#"}
                    target={documentURL ? "_blank" : "_self"}
                    rel={"noopener noreferrer"}
                  >
                    <AddToolTip
                      name={`${doc?.name}.${doc?.extension ?? "jpg"}`}
                    />
                  </a>
                </div>
                <div className="ft-12 fw-400 loan-label-color p-3 w-25">
                  {doc?.size != undefined ? byteConverter(doc?.size) : ""}
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <div className="d-flex justify-content-center p-2 loan-document-details w-50">
          No data available
        </div>
      )}
    </div>
  );
};

export default Documents;
